export default {
  priorityRules: (state) => state.priorityRules,

  priorityInfrastructure: (state) => {
    return state.priorityInfrastructure.map((v) => {
      return {
        ...v,
        id: v.user_id || v.id
      }
    })
  },

  /**
   * Источники для привязок потоков (Настройка потоков)
   * Могут быть выделенные или административные территории
   * @param {*} state
   * @param {*} getters
   * @returns
   */
  prioritySource: (state, getters) => {
    //Административные территории
    const admTerritories = (getters.admTerritories || []).filter((territory) => {
      return territory.adm_level > 4 //Уровни только после региона
    })

    //Выделеннные территории
    const separatedTerritories = (getters.separatedTerritories || []).map((territory) => {
      return {
        ...territory,
        adm_level: 20 //Костыль, бэк не отдает уровень 20 в эндпоинте выделенных территорий
      }
    })

    return [...admTerritories, ...separatedTerritories]
  },

  /**
   * Словарь источников привязок (Форма настройки потоков)
   * @param {*} state
   * @param {*} getters
   * @returns
   */
  prioritySourceMap: (state, getters) => {
    return getters.prioritySource.reduce((result, territory) => {
      result[territory.id] = territory
      return result
    }, {})
  },

  priorityInfrastructureMap: (state, getters) => {
    const object = {}
    getters.priorityInfrastructure.forEach((v) => {
      object[v.id] = v
    })
    return getters.priorityInfrastructure.length ? object : null
  },

  priorityFlowsWithSource: (state) => {
    return state.priorityFlows.filter((priorityFlow) => {
      //Откуда-то попадают привязки без источника. Похоже что при редактировании до того как пройдет сохранение на сервер
      //TODO: выяснить откуда и убрать костыль
      return priorityFlow.source || priorityFlow.source_infrastructure || priorityFlow.source_infrastructure_user_id
    })
  },

  priorityFlows: (state, getters) => {
    if (!getters.priorityInfrastructureMap || !getters.prioritySourceMap) {
      return []
    }

    return getters.priorityFlowsWithSource
      .map((priorityFlow) => {
        const infrastructureKey = priorityFlow.source_infrastructure || priorityFlow.source_infrastructure_user_id
        const obj = infrastructureKey ? getters.priorityInfrastructureMap[infrastructureKey] : getters.prioritySourceMap[priorityFlow.source]

        //Переходный момент, у выделенных территорий treatment_type у административных treatment_types
        const objTreatmentTypes = obj.treatment_type || obj.treatment_types || []

        return {
          ...priorityFlow,
          infrastructures: priorityFlow.infrastructures.filter((infrastructureItem) => {
            const targetInfrastructureKey = infrastructureItem.infrastructure || infrastructureItem.infrastructure_user_id

            return (
              (!infrastructureKey ||
                getters.priorityInfrastructureMap[targetInfrastructureKey].rank > getters.priorityInfrastructureMap[infrastructureKey].rank) &&
              obj &&
              objTreatmentTypes.indexOf(infrastructureItem.treatment_type) > -1 &&
              getters.priorityInfrastructureMap[targetInfrastructureKey] &&
              getters.priorityInfrastructureMap[targetInfrastructureKey].treatment_input.indexOf(infrastructureItem.treatment_type) > -1
            )
          })
        }
      })
      .filter((v) => v.infrastructures.length)
  },

  wrongPriorityFlows: (state, getters) => {
    const wrong = []
    if (!getters.priorityInfrastructureMap || !getters.prioritySourceMap) {
      return null
    }
    getters.priorityFlowsWithSource.forEach((priorityFlow) => {
      const infrastructureKey = priorityFlow.source_infrastructure || priorityFlow.source_infrastructure_user_id
      const obj = infrastructureKey ? getters.priorityInfrastructureMap[infrastructureKey] : getters.prioritySourceMap[priorityFlow.source]

      //Переходный момент, у выделенных территорий treatment_type у административных treatment_types
      const objTreatmentTypes = obj.treatment_type || obj.treatment_types || []

      const validInfrastructures = priorityFlow.infrastructures.filter((infrastructureItem) => {
        const targetInfrastructureKey = infrastructureItem.infrastructure || infrastructureItem.infrastructure_user_id

        return (
          (!infrastructureKey || getters.priorityInfrastructureMap[targetInfrastructureKey].rank > getters.priorityInfrastructureMap[infrastructureKey].rank) &&
          obj &&
          objTreatmentTypes.indexOf(infrastructureItem.treatment_type) > -1 &&
          getters.priorityInfrastructureMap[targetInfrastructureKey] &&
          getters.priorityInfrastructureMap[targetInfrastructureKey].treatment_input.indexOf(infrastructureItem.treatment_type) > -1
        )
      })

      if (validInfrastructures.length < priorityFlow.infrastructures.length) {
        const reason1 = priorityFlow.infrastructures.filter(
          (v) =>
            !priorityFlow.source_infrastructure ||
            getters.priorityInfrastructureMap[v.infrastructure].rank > getters.priorityInfrastructureMap[priorityFlow.source_infrastructure].rank
        )

        const reason2 = priorityFlow.infrastructures.filter((v) => {
          return obj && objTreatmentTypes.indexOf(v.treatment_type) > -1
        })

        const reason3 = priorityFlow.infrastructures.filter(
          (v) =>
            getters.priorityInfrastructureMap[v.infrastructure] &&
            getters.priorityInfrastructureMap[v.infrastructure].treatment_input.indexOf(v.treatment_type) > -1
        )

        console.log(
          priorityFlow,
          'Всего целевых ОИ:',
          priorityFlow.infrastructures.length,
          'Валидные ОИ по параметрам: ранги для ОИ',
          reason1,
          'tr_type/tr_output источника',
          reason2,
          ', tr_input приемника',
          reason3
        )
        wrong.push({
          ...priorityFlow,
          infrastructures: validInfrastructures
        })
      }
    })
    return wrong.length ? wrong : null
  },
  showPriorityModal: (state) => state.showPriorityModal,
  priorityMapData: (state) => state.priorityMapData,
  priorityPeriod: (state) => state.priorityPeriod,
  priorityMapParams: (state) => state.priorityMapParams,
  priorityFlowAction: (state) => state.priorityFlowAction,
  forceUpdatePriorityFlows: (state) => state.forceUpdatePriorityFlows,
  priorityRuleToEdit: (state) => state.priorityRuleToEdit,
  priorityLoadingData: (state) => state.priorityLoadingData
}



// WEBPACK FOOTER //
// ./src/store/priorities/getters.js